import React, { useEffect, useLayoutEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import PromotionalBanner from './components/PromotionalBanner';
import Home from './pages/Home';
import CategoryPage from './pages/CategoryPage';
import About from './pages/About';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import PaymentSuccess from './pages/PaymentSuccess';
import Contact from './pages/Contact';
import CustomerGallery from './pages/CustomerGallery';
import './App.css';

// Disable browser scroll restoration globally
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

const ScrollToTop = () => {
  const location = useLocation();

  // Force scroll to top before paint on every route change
  useLayoutEffect(() => {
    // Strip any URL hash to prevent anchor-based scroll
    if (window.location.hash) {
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    }

    // Only skip for explicit "Back to Collections" scroll intent
    if (location.state?.scrollTo) return;

    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [location.pathname, location.key]);

  // Secondary reset after render to catch any late layout shifts
  useEffect(() => {
    if (location.state?.scrollTo) return;

    const raf = requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });
    return () => cancelAnimationFrame(raf);
  }, [location.pathname, location.key]);

  // Track page views in Google Analytics on route change
  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'G-SFMGZNWMG6', { page_path: location.pathname });
    }
  }, [location.pathname]);

  return null;
};

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="min-h-screen bg-[#F5F2EB] text-[#2C1810]">
          <PromotionalBanner />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/woodwork-and-art" element={<CategoryPage category="woodwork_and_art" />} />
            <Route path="/mandirs" element={<CategoryPage category="mandirs" />} />
            <Route path="/copperware" element={<CategoryPage category="copperware" />} />
            <Route path="/candles" element={<CategoryPage category="candles" />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/gallery" element={<CustomerGallery />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
          </Routes>
          <Footer />
          <WhatsAppButton />
        </div>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
